import { parse, unparse } from 'papaparse'

export const CSV = {
    parse({ file, complete, error }) {
        return parse(file, {
            delimiter: ',',
            worker: true,
            header: true,
            skipEmptyLines: true,
            complete: complete,
            error: error,
        })
    },

    parseRemoteFile({ file, complete, error }) {
        return parse(file, {
            download: true,
            delimiter: ',',
            worker: true,
            header: true,
            skipEmptyLines: true,
            complete: complete,
            error: error,
        })
    },

    createFile(data, filename = 'merged.csv') {
        const string = unparse(data)
        // const array = string.split('\r\n')
        // log(array)
        const file = new File([string], filename, {
            type: 'text/csv',
        })
        return file
    },

    downloadFile(file) {
        const objectURL = URL.createObjectURL(file)
        window.location = objectURL
        return objectURL
    },

    downloadCSVFile(file) {
        const createFile = this.createFile(file)
        return this.downloadFile(createFile)
    },
}
